module.exports = __webpack_public_path__ + "static/media/home_cbhr.9f17aa91.png";